<template>
  <div class="authorization-guide">
    <el-card class="guide-container">
      <template #header>
        <div class="guide-header">
          <h2>授权指南</h2>
        </div>
      </template>

      <!-- Tab切换 -->
      <el-tabs v-model="activeTab" type="card" @tab-click="handleTabChange">
        <!-- 京东授权 -->
        <el-tab-pane label="京东授权" name="jd">
          <div class="auth-content">
            <h3>京东应用授权流程</h3>
            <p class="description">京东授权分为【应用授权】和【小部件授权】请根据自己的授权对象分别设置第1或者第2步骤,最终的授权链接拼接方案都是一样</p>

            <!-- 步骤说明 -->
            <div class="steps-container">
              <div class="step-item">
                <div class="step-number">1</div>
                <div class="step-content">
                  <h4>应用设置</h4>
                  <p>【应用设置】→【基本信息】→【服务器域名】: <code>https://oauth-jd.morefun.me</code></p>
                  <p>【应用设置】→【基本信息】→【回调URL】: <code>https://oauth-jd.morefun.me/api/page/openid</code></p>
                </div>
              </div>

              <div class="step-item">
                <div class="step-number">2</div>
                <div class="step-content">
                  <h4>小部件设置</h4>
                  <p>【小部件设置】→【域名配置】: <code>https://oauth-jd.morefun.me</code></p>
                  <p>【小部件设置】→【回调URL】: <code>https://oauth-jd.morefun.me/api/page/openid</code></p>
                </div>
              </div>

              <div class="step-item">
                <div class="step-number">3</div>
                <div class="step-content">
                  <h4>拼接授权地址</h4>
                  <p>做好第1或第2步之后,第3步直接替换应用的appkey和Secret(或者小部件的appId和appSecret,小部件不知道怎么获取可以联系后端开发)</p>

                  <!-- 输入表单 -->
                  <div class="input-form">
                    <el-form :model="jdForm" :rules="jdRules" ref="jdFormRef" label-position="top">
                      <el-form-item label="App Key / App ID" prop="appKey">
                        <el-input v-model="jdForm.appKey" placeholder="请输入您的App Key或App ID" clearable @input="resetJdGenerated" />
                      </el-form-item>

                      <el-form-item label="Secret / App Secret" prop="secret">
                        <el-input v-model="jdForm.secret" placeholder="请输入您的Secret或App Secret" type="password" show-password clearable @input="resetJdGenerated" />
                      </el-form-item>
                    </el-form>

                    <!-- 生成按钮 -->
                    <div class="generate-actions">
                      <el-button type="primary" @click="generateJdAuthUrl" :disabled="!jdForm.appKey || !jdForm.secret">
                        生成授权链接
                      </el-button>
                    </div>

                    <!-- 拼接结果 -->
                    <div class="result-section" v-if="jdAuthUrl">
                      <h5>生成的授权链接:</h5>
                      <div class="url-display">
                        <el-input v-model="jdAuthUrl" readonly type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" />
                        <div class="url-actions">
                          <el-button type="primary" size="small" @click="copyJdUrl">
                            复制链接
                          </el-button>
                          <el-button type="success" size="small" @click="openJdAuth">
                            跳转授权
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <!-- 淘宝授权 -->
        <el-tab-pane label="淘宝授权" name="taobao" disabled>
          <div class="auth-content">
            <h3>淘宝应用授权流程</h3>
            <p class="description">淘宝授权需要在开发者后台进行相应的配置，然后通过以下步骤生成授权链接。</p>

            <!-- 步骤说明 -->
            <div class="steps-container">
              <div class="step-item">
                <div class="step-number">1</div>
                <div class="step-content">
                  <h4>开发者后台设置</h4>
                  <p>【应用管理】→【应用信息】→【授权回调地址】: <code>https://oauth-tb.morefun.me</code></p>
                </div>
              </div>

              <div class="step-item">
                <div class="step-number">2</div>
                <div class="step-content">
                  <h4>获取应用凭证</h4>
                  <p>在【应用管理】→【应用信息】中获取您的App Key和App Secret</p>
                </div>
              </div>

              <div class="step-item">
                <div class="step-number">3</div>
                <div class="step-content">
                  <h4>拼接授权地址</h4>
                  <p>使用您的App Key和App Secret生成授权链接</p>

                  <!-- 输入表单 -->
                  <div class="input-form">
                    <el-form :model="tbForm" :rules="tbRules" ref="tbFormRef" label-position="top">
                      <el-form-item label="App Key" prop="appKey">
                        <el-input v-model="tbForm.appKey" placeholder="请输入您的淘宝App Key" clearable @input="resetTbGenerated" />
                      </el-form-item>

                      <el-form-item label="App Secret" prop="secret">
                        <el-input v-model="tbForm.secret" placeholder="请输入您的淘宝App Secret" type="password" show-password clearable @input="resetTbGenerated" />
                      </el-form-item>
                    </el-form>

                    <!-- 生成按钮 -->
                    <div class="generate-actions">
                      <el-button type="primary" @click="generateTbAuthUrl" :disabled="!tbForm.appKey || !tbForm.secret">
                        生成授权链接
                      </el-button>
                    </div>

                    <!-- 拼接结果 -->
                    <div class="result-section" v-if="tbAuthUrl">
                      <h5>生成的授权链接:</h5>
                      <div class="url-display">
                        <el-input v-model="tbAuthUrl" readonly type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" />
                        <div class="url-actions">
                          <el-button type="primary" size="small" @click="copyTbUrl">
                            复制链接
                          </el-button>
                          <el-button type="success" size="small" @click="openTbAuth">
                            跳转授权
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { ElMessage } from 'element-plus'

// 当前激活的tab
const activeTab = ref('jd')

// 京东表单数据
const jdForm = ref({
  appKey: '',
  secret: ''
})

// 淘宝表单数据
const tbForm = ref({
  appKey: '',
  secret: ''
})

// 京东表单验证规则
const jdRules = ref({
  appKey: [
    { required: true, message: '请输入App Key或App ID', trigger: 'blur' }
  ],
  secret: [
    { required: true, message: '请输入Secret或App Secret', trigger: 'blur' }
  ]
})

// 淘宝表单验证规则
const tbRules = ref({
  appKey: [
    { required: true, message: '请输入淘宝App Key', trigger: 'blur' }
  ],
  secret: [
    { required: true, message: '请输入淘宝App Secret', trigger: 'blur' }
  ]
})

// 表单引用
const jdFormRef = ref()
const tbFormRef = ref()

// 生成状态控制
const jdGenerated = ref(false)
const tbGenerated = ref(false)

// 京东授权URL（仅在生成后显示）
const jdAuthUrl = computed(() => {
  if (!jdGenerated.value || !jdForm.value.appKey || !jdForm.value.secret) {
    return ''
  }
  return `https://oauth-jd.morefun.me/api/auth/getAccessToken?appKey=${encodeURIComponent(jdForm.value.appKey)}&secret=${encodeURIComponent(jdForm.value.secret)}&callback=https://oauth-jd.morefun.me/api/page/openid`
})

// 淘宝授权URL（仅在生成后显示）
const tbAuthUrl = computed(() => {
  if (!tbGenerated.value || !tbForm.value.appKey || !tbForm.value.secret) {
    return ''
  }
  return `https://oauth-tb.morefun.me/api/auth/getAccessToken?appKey=${encodeURIComponent(tbForm.value.appKey)}&secret=${encodeURIComponent(tbForm.value.secret)}&callback=https://oauth-tb.morefun.me/api/page/openid`
})

// Tab切换处理
const handleTabChange = (tab) => {
  activeTab.value = tab.name
}

// 生成京东授权URL
const generateJdAuthUrl = async () => {
  if (jdFormRef.value) {
    try {
      await jdFormRef.value.validate()
      jdGenerated.value = true
      ElMessage.success('京东授权链接生成成功！')
    } catch (error) {
      ElMessage.error('请填写完整的京东授权信息')
    }
  }
}

// 生成淘宝授权URL
const generateTbAuthUrl = async () => {
  if (tbFormRef.value) {
    try {
      await tbFormRef.value.validate()
      tbGenerated.value = true
      ElMessage.success('淘宝授权链接生成成功！')
    } catch (error) {
      ElMessage.error('请填写完整的淘宝授权信息')
    }
  }
}

// 监听表单变化，重置生成状态
const resetJdGenerated = () => {
  jdGenerated.value = false
}

const resetTbGenerated = () => {
  tbGenerated.value = false
}

// 复制京东URL
const copyJdUrl = async () => {
  try {
    await navigator.clipboard.writeText(jdAuthUrl.value)
    ElMessage.success('京东授权链接已复制到剪贴板')
  } catch (error) {
    ElMessage.error('复制失败，请手动复制')
  }
}

// 复制淘宝URL
const copyTbUrl = async () => {
  try {
    await navigator.clipboard.writeText(tbAuthUrl.value)
    ElMessage.success('淘宝授权链接已复制到剪贴板')
  } catch (error) {
    ElMessage.error('复制失败，请手动复制')
  }
}

// 跳转京东授权
const openJdAuth = () => {
  if (jdAuthUrl.value) {
    window.open(jdAuthUrl.value, '_blank')
  }
}

// 跳转淘宝授权
const openTbAuth = () => {
  if (tbAuthUrl.value) {
    window.open(tbAuthUrl.value, '_blank')
  }
}
</script>

<style scoped>
.authorization-guide {
  padding: 20px;
}

.guide-container {
  min-height: 600px;
}

.guide-header h2 {
  margin: 0;
  color: #333;
  font-size: 24px;
}

.auth-content {
  padding: 20px 0;
}

.auth-content h3 {
  margin-bottom: 16px;
  color: #333;
  font-size: 20px;
}

.description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 24px;
}

.steps-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.step-item {
  display: flex;
  gap: 16px;
  padding: 16px;
  background: #f9f9f9;
  border-radius: 8px;
  border-left: 4px solid #409eff;
}

.step-number {
  min-width: 32px;
  height: 32px;
  background: #409eff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  flex-shrink: 0;
}

.step-content {
  flex: 1;
}

.step-content h4 {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 16px;
}

.step-content p {
  margin: 0;
  color: #666;
  line-height: 1.5;
}

.step-content code {
  background: #f0f0f0;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 14px;
}

.input-form {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #eee;
}

.result-section {
  margin-top: 20px;
}

.result-section h5 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 16px;
}

.url-display {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.url-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.generate-actions {
  margin-top: 20px;
  text-align: right;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .step-item {
    flex-direction: column;
  }

  .step-number {
    align-self: flex-start;
  }

  .url-actions {
    flex-direction: column;
  }
}
</style>
